import Emr from "./Emr.jsx"

export default Emr;